"use client";

import Link from "next/link";
import posthog from "posthog-js";
import { ArrowRight } from "lucide-react";

interface MarketingCTAProps {
  heading?: string;
  description?: string;
  buttonText?: string;
  buttonHref?: string;
  trustText?: string;
}

export function MarketingCTA({
  heading = "Less overhead, more craft",
  description = "Free for small teams. Set up in minutes.",
  buttonText = "Try it free",
  buttonHref = "/auth",
  trustText = "No credit card required",
}: MarketingCTAProps) {
  const handleClick = () => {
    if (typeof window !== "undefined" && posthog?.__loaded) {
      posthog.capture("marketing_cta_clicked", {
        cta: "footer_primary",
        location: "footer",
        href: buttonHref,
      });
    }
  };

  return (
    <section className="py-16 sm:py-24 px-4 sm:px-6 bg-gray-900 text-white">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 sm:mb-6">
          {heading}
        </h2>
        <p className="text-lg sm:text-xl text-gray-300 mb-6 sm:mb-10 max-w-2xl mx-auto">
          {description}
        </p>
        <Link
          href={buttonHref}
          onClick={handleClick}
          className="inline-flex items-center gap-2 px-8 py-4 bg-white text-gray-900 font-semibold hover:bg-gray-100 transition-all rounded-lg text-lg shadow-lg hover:shadow-xl group"
        >
          {buttonText}
          <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" />
        </Link>
        {trustText && (
          <p className="mt-6 text-gray-400 text-sm">{trustText}</p>
        )}
      </div>
    </section>
  );
}
